import { getNotaryOrdersInvoicesDt } from "~/helpers/backendHelper";
import { getNotaryOrdersInvoicesDtErr, getNotaryOrdersInvoicesDtOk } from "./actions";
import { GET_NOTARY_ORDERS_INVOICES_DT } from "./actionTypes";
import { takeEvery, put, call } from "redux-saga/effects";

/********** DATATABLE **********/

function* onGetNotaryOrdersInvoicesDt({ payload: { params } }) {
  try {
    const response = yield call(getNotaryOrdersInvoicesDt, params);
    yield put(getNotaryOrdersInvoicesDtOk(response));
  } catch (error) {
    yield put(getNotaryOrdersInvoicesDtErr(error));
  }
}

function* notaryOrdersInvoicesSaga() {
  yield takeEvery(GET_NOTARY_ORDERS_INVOICES_DT, onGetNotaryOrdersInvoicesDt);
}

export default notaryOrdersInvoicesSaga;